import ReactGA from "react-ga4";
import hotjar from "@hotjar/browser";

export function useAnalytics() {
  const trackGA4Event = (eventName: string, params?: Record<string, any>) => {
    try {
      ReactGA.event(eventName, params || {});
    } catch (err) {
      // console.warn("GA4 tracking failed:", err);
    }
  };

  const trackHotjarEvent = (eventName: string) => {
    try {
      hotjar.event(eventName);
    } catch (err) {
      // console.warn("Hotjar event failed:", err);
    }
  };

  const trackAllEvents = (eventName: string, params?: Record<string, any>) => {
    trackGA4Event(eventName, params);
    trackHotjarEvent(eventName);
  };

  return {
    trackGA4Event,
    trackHotjarEvent,
    trackAllEvents
  };
}
